// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__W9Aws","colMin":"styles_colMin__l8P2j","colCheckbox":"styles_colCheckbox__2FUBO"};